import React from "react";
import { DeleteConfirmModalProps } from "../Interfaces/Interface";
const DeleteFunctionChecklist: React.FC<DeleteConfirmModalProps> = ({ onCancel, onConfirm }) => {
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Confirm Deletion</h3>
                <p>Are you sure you want to delete this question?</p>
                <div className="buttons">
                    <button className="cancelbutton" onClick={onCancel}>Cancel</button>
                    <button className="savebutton" onClick={onConfirm}>Delete</button>
                </div>
            </div>
        </div>
    );
};
export default DeleteFunctionChecklist;